/**
 * getDimensionsFromImgFile
 * To check the dimension of an image file we have
 * to load it into an image object first, then ask
 * the object for it's dimensions.
 * One note on testing, Jest doesn't allow the image.onload
 * to fire, so it has to be mocked.
 *
 * A read can stall with neither onload nor onerror ever firing
 * (e.g. a file on a network/cloud drive), so a timeout rejects the
 * promise instead of leaving it pending forever. See DEV-7534.
*/
const READ_TIMEOUT_MS = 10000;

export const getDimensionsFromImgFile = (file, timeoutMs = READ_TIMEOUT_MS) => {
  return new Promise((resolve, reject) => {
    let timer;
    const settle = (fn) => (arg) => {
      clearTimeout(timer);
      fn(arg);
    };
    const done = settle(resolve);
    const fail = settle(reject);
    try {
      if (!file?.type?.includes("image/")) {
        throw (new Error("Not an image file"));
      }
      timer = setTimeout(
        () => fail(new Error("Timed out reading image file")),
        timeoutMs
      );
      const reader = new FileReader();
      reader.onload = function (e) {
        const img = new Image();
        img.onload = function () {
          const dim = { width: this.width, height: this.height };
          done(dim);
        }
        img.onerror = function (err) {
          fail(err);
        }
        img.src = e.target.result;
      }
      reader.onerror = function (err) {
        fail(err);
      }
      reader.readAsDataURL(file);
    } catch (error) {
      return fail(error);
    }
  })
};
